import { useEffect, useRef } from "react";
import { useTemplatesStatusStore } from "../store/useTemplatesStatusStore";

export const REMOTE_SAVE_INTERVAL = 3000;
const TEMPLATES_BULK_UPDATE_INTERVAL = 5;

export const useTemplateAutoSave = (
  handleSave: () => Promise<void>,
  handleBulkSave: () => Promise<void>
) => {
  const isSavingRef = useRef(false);
  const intervalCountRef = useRef(0);
  const handleSaveRef = useRef(handleSave);
  const handleBulkSaveRef = useRef(handleBulkSave);

  useEffect(() => {
    handleSaveRef.current = handleSave;
  }, [handleSave]);

  useEffect(() => {
    handleBulkSaveRef.current = handleBulkSave;
  }, [handleBulkSave]);

  useEffect(() => {
    const saveIntervalId = setInterval(() => {
      const currentUpdates = useTemplatesStatusStore.getState().updates;
      const currentBulkUpdates = useTemplatesStatusStore.getState().bulkUpdates;

      if (
        !isSavingRef.current &&
        currentUpdates > 0 &&
        intervalCountRef.current !== TEMPLATES_BULK_UPDATE_INTERVAL
      ) {
        isSavingRef.current = true;
        void handleSaveRef
          .current()
          .catch((error) => console.error("Error saving template", error))
          .finally(() => {
            isSavingRef.current = false;
          });
      }

      if (intervalCountRef.current === TEMPLATES_BULK_UPDATE_INTERVAL) {
        if (!isSavingRef.current && currentBulkUpdates > 0) {
          isSavingRef.current = true;
          void handleBulkSaveRef
            .current()
            .catch((error) => console.error("Error saving bulk updates", error))
            .finally(() => {
              isSavingRef.current = false;
            });
        }
        intervalCountRef.current = 0;
      }

      intervalCountRef.current++;
    }, REMOTE_SAVE_INTERVAL);

    return () => {
      clearInterval(saveIntervalId);
    };
  }, []);
};
